import { useMemo } from 'react'
import { useRouter } from 'next/router'

import {
  QUERY_PARAMS,
  WEB_CLIENTS,
  MOBILE_CLIENTS,
  ROUTES,
  SCOPE,
  IOS_CLIENTS,
  ANDROID_CLIENTS,
  DESKTOP_CLIENTS,
  OAUTH_CLIENTS,
} from '@/constants'
import { getQueryParamValueAsString } from '@/utils/url'

const SCOPELESS_ROUTES = [
  ROUTES[404],
  ROUTES[500],
  ROUTES.maintenance,
  ROUTES.scanSnapAuthorization,
  ROUTES.authenticated,
  ROUTES.oauthAuthorization,
]

export default function useScope() {
  const router = useRouter()

  const scope = getQueryParamValueAsString(QUERY_PARAMS.scope, router.query) ?? ''

  const value = useMemo(
    () => ({
      scope,
      isWebClient: WEB_CLIENTS.includes(scope),
      isMobileClient: MOBILE_CLIENTS.includes(scope),
      scopelessPaths: SCOPELESS_ROUTES,
      isScopeValid: Object.values(SCOPE).includes(scope),
      isIOSClient: IOS_CLIENTS.includes(scope),
      isAndroidClient: ANDROID_CLIENTS.includes(scope),
      isDesktopClient: DESKTOP_CLIENTS.includes(scope),
      isOauthClient: OAUTH_CLIENTS.includes(scope),
    }),
    [scope],
  )

  return value
}
